import { EventBus } from '@gh/grub-foundation';

const eventBus = new EventBus();

export { eventBus };
